interface Event {
  title: string;
  start: string;
  end?: string;
  relativeUrl?: string;
  location?: string;
}

interface DayProgram {
  date: string;
  events: Event[];
}

const program: DayProgram[] = [
  {
    date: "09.09.2025",
    events: [
      {
        title: "Åpningsforedrag med Peter Warren",
        start: "11:15",
        end: "12:15",
        location: "S8",
      },
      {
        title: "Ballongslipp!",
        start: "12:15",
        location: "Element-kantinen",
      },
    ],
  },
  {
    date: "10.09.2025",
    events: [
      {
        title: "Åpen karrieremesse",
        start: "10:00",
        end: "15:00",
        location: "Frimerket",
      },
      {
        title: "Summer internship presentasjoner",
        start: "12:15",
        end: "13:15",
        location: "EL6",
        relativeUrl: "/kd/summer-internship-presentasjoner/",
      },
      {
        title: "Bedriftspresentasjon med BDO",
        start: "17:15",
        location: "Kjel 1",
      },
    ],
  },
  {
    date: "11.09.2025",
    events: [
      {
        title: "Frokost med Accenture",
        start: "08:00",
        end: "10:00",
        location: "Scandic Nidelven",
      },
      {
        title: "Åpen karrieremesse",
        start: "10:00",
        end: "15:00",
        location: "Frimerket",
      },
      {
        title: "Summer internship presentasjoner",
        start: "11:15",
        end: "12:15",
        location: "S8",
        relativeUrl: "/kd/summer-internship-presentasjoner/",
      },
      {
        title: "Inspirasjonsforedrag med Camilla Stoltenberg",
        start: "12:15",
        end: "13:00",
        location: "S5",
      },
      {
        title: "Sirkeltrening med Sweco",
        start: "17:00",
        location: "Sal 4",
      },
    ],
  },
  {
    date: "12.09.2025",
    events: [
      {
        title: "Frokost med Equinor",
        start: "08:00",
        end: "10:00",
        location: "Scandic Nidelven",
      },
      {
        title: "Åpen karrieremesse",
        start: "10:00",
        end: "15:00",
        location: "Frimerket",
      },
      {
        title: "Summer internship presentasjoner",
        start: "12:00",
        end: "13:45",
        location: "Kjel 1",
        relativeUrl: "/kd/summer-internship-presentasjoner/",
      },
      {
        title: "KarriereKvelden 2024",
        start: "19:00",
        end: "00:00",
        location: "Frimurerlogen",
        relativeUrl: "/kd/karrierekvelden/",
      },
    ],
  },
];

export default program;
